var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: { visible: _vm.drawer, size: "60%" },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("BjPage", {
                ref: "BjPage",
                attrs: {
                  "query-params": _vm.queryParams,
                  "get-action": _vm.queryApi,
                  "search-btn-hide": true,
                  serial: _vm.serial,
                },
                on: {
                  showSetting: _vm.SortableTable.show,
                  "header-dragend": _vm.SortableTable.handleHeaderDragend,
                  "header-contextmenu":
                    _vm.SortableTable.handleHeaderContextmenu,
                },
                scopedSlots: _vm._u([
                  {
                    key: "tableOperation",
                    fn: function () {
                      return [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "main-btn",
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onAdd()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("addText")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "tableColumn",
                    fn: function () {
                      return [
                        _vm._l(_vm.dropCols, function (col, index) {
                          return [
                            col.prop !== "bjTableAction"
                              ? _c("el-table-column", {
                                  key:
                                    "col_" +
                                    index +
                                    "_" +
                                    col.prop +
                                    "_" +
                                    (col.width || "auto"),
                                  attrs: {
                                    prop: col.prop,
                                    label: col.label,
                                    width: col.width || "auto",
                                    fixed: col.fixed || false,
                                    align: "center",
                                    "class-name": "item",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            false
                                              ? void 0
                                              : col.prop === "logisticsName"
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "link",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openInside(
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row[col.prop]
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : col.prop === "profitMargin"
                                              ? [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row[col.prop]
                                                      ) + " %"
                                                    ),
                                                  ]),
                                                ]
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("timeFilters")(
                                                        scope.row[col.prop],
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            col.prop === "bjTableAction"
                              ? _c("el-table-column", {
                                  key:
                                    "col_" +
                                    index +
                                    "_" +
                                    col.prop +
                                    "_" +
                                    (col.width || "auto"),
                                  attrs: {
                                    prop: col.prop,
                                    label: col.label,
                                    width: col.width || "auto",
                                    fixed: col.fixed || "right",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.outsideFormCopy(
                                                      props.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("copyText"))
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.outsideFormDel(
                                                      props.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("delText"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                          ]
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("InsideDrawer", {
                ref: "InsideDrawer",
                on: {
                  openInsideDialog: _vm.openInsideDialog,
                  homeReFresh: _vm.homeReFresh,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleTwo,
            width: "500px",
            "before-close": _vm.handleClose2,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleTwo = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form2",
              attrs: {
                model: _vm.form2,
                "status-icon": "",
                rules: _vm.rules2,
                "label-position": "top",
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.chooseLogistics"),
                    prop: "logisticsName",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      "option-list": _vm.LogisticsList,
                      placeholder: _vm.$t(
                        "LogisticsRulesTable.header.Logistics"
                      ),
                      clearable: "",
                    },
                    model: {
                      value: _vm.form2.logisticsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "logisticsName", $$v)
                      },
                      expression: "form2.logisticsName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose2 } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm2()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisibleThree,
            width: "500px",
            "before-close": _vm.handleClose3,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleThree = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form3",
              attrs: {
                model: _vm.form3,
                "status-icon": "",
                rules: _vm.rules3,
                "label-position": "top",
                "label-width": "100px",
              },
            },
            [
              !_vm.form3.id
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.zoneGroup"),
                        prop: "logisticsGroupName",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.logisticsGroupList,
                          placeholder: _vm.$t("billingPage.zoneGroup"),
                        },
                        on: { change: _vm.getName },
                        model: {
                          value: _vm.form3.logisticsGroupName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form3, "logisticsGroupName", $$v)
                          },
                          expression: "form3.logisticsGroupName",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "businessLogisticsCompanyBusiness.table.ProfitMargin"
                    ),
                    prop: "profitMargin",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "businessLogisticsCompanyBusiness.table.ProfitMargin"
                        ),
                        clearable: "",
                      },
                      model: {
                        value: _vm.form3.profitMargin,
                        callback: function ($$v) {
                          _vm.$set(_vm.form3, "profitMargin", $$v)
                        },
                        expression: "form3.profitMargin",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("%")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose3 } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onConfirm3()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }